import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { default as ordersStore } from 'store/ordersStore';
import { Positions } from 'constants/enums';
import agent from 'api/agent';
import { useStyles } from '../styles';
import { useAppSelector } from 'index';
import { SignalREvent, signalRService } from 'services/signalR';

export default function NewOrdersCounter(props: { isOpen: boolean }) {
    const classes = useStyles();
    const newOrders = useAppSelector((state) => state.orders.newOrders);
    const user = useAppSelector((state) => state.user);
    const currentPosition = useAppSelector((state) => state.user).restaurants.find(
        (res) => res.id === user.currentRestaurantId
    )?.currentPosition;
    const language = useAppSelector((state) => state.global.language);
    const dispatch = useDispatch();
    const userRestaurantId = useRef('');
    const userCurrentPosition = useRef<Positions | undefined>(undefined);

    useEffect(() => {
        if (user.currentRestaurantId) {
            userRestaurantId.current = user.currentRestaurantId;
        } else {
            agent.User.GetUserRestaurants().then((response) => {
                userRestaurantId.current = response.currentRestaurantId;
                dispatch({
                    type: 'USER_GET_RESTAURANTS_SUCCESS',
                    restaurants: response,
                });
            });
        }
    }, [user.currentRestaurantId]); // eslint-disable-line

    useEffect(() => {
        if (currentPosition) {
            userCurrentPosition.current = currentPosition;
            dispatch(ordersStore.actionCreators.getNewOrders(Positions.WAITER));
        }

        //TRY TO DISABLE GET NEW ORDERS LOOP
        /* const timer = setInterval(() => {
            dispatch(OrdersStore.actionCreators.getNewOrders());
        }, 60000);
        return () => clearInterval(timer); */
    }, [currentPosition]); // eslint-disable-line

    useEffect(() => {
        return signalRService.subscribe(SignalREvent.OrdersCountChanged, handleMessage);
    }, []);

    function handleMessage(count: number) {
        ordersStore.actionCreators.setNewOrdersCount(count);
    }

    function calculateLeftSpace() {
        if (!props.isOpen) {
            return 35;
        } else {
            return language === 'en' ? 120 : 160;
        }
    }

    function getWidth() {
        if (newOrders > 99) {
            return 22;
        }
        if (newOrders > 9) {
            return 16;
        }
        return 12;
    }

    return (
        <div style={{ position: 'relative' }} key="newOrders">
            <div
                className={classes.newOrdersCount}
                style={{ left: calculateLeftSpace(), width: getWidth() }}
            >
                {newOrders}
            </div>
        </div>
    );
}
